
import Accordion from './Accordion';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';



function Patientwarmingsysteminpatna() {



  const cardData =
  {
    keyword: 'Patient Warming Systems in Patna',
    heading: 'Pharmacle Health Care Private Limited: Patient Warming Systems in Patna',
    headingDescription: 'Pharmacle Health Care Private Limited provides high-quality Patient Warming Systems in Patna, ensuring optimal temperature management for patients during surgeries and critical care. Our Wallabies Warm Care systems are designed to prevent hypothermia by delivering consistent and controlled warming, enhancing patient safety and recovery. Widely used in hospitals and healthcare facilities, our patient warming systems are reliable, easy to use, and built with advanced technology. Choose Pharmacle Health Care for the best warming solutions in Patna to improve patient care and clinical outcomes.',

    top: 'Pharmacle Health Care Private Limited – Leading Provider of Forced Air-Warming Systems & Blankets',


    "topPlaces": [
  {
    "title": "Advanced Patient Warming Systems in Patna",
    "description": "Pharmacle Health Care Private Limited offers cutting-edge Patient Warming Systems in Patna, designed to maintain optimal body temperature for patients during surgeries, ICU treatments, and recovery care. Our systems reduce hypothermia risks and improve clinical outcomes."
  },
  {
    "title": "Forced Air Warming System in Patna",
    "description": "Our Forced Air Warming System delivers safe, uniform, and consistent heat distribution, making it essential for surgical theaters and intensive care units in Patna. Prevent perioperative hypothermia and ensure superior patient safety."
  },
  {
    "title": "Portable Patient Warming Device for Emergency Use",
    "description": "Pharmacle Health Care’s Portable Patient Warming Device is lightweight, efficient, and perfect for ambulances, emergency wards, and home healthcare in Patna. It ensures quick temperature stabilization for patients in transit."
  },
  {
    "title": "Neonatal Patient Warming System in Patna",
    "description": "Specially crafted for newborns, our Neonatal Patient Warming Systems provide gentle and precise temperature control. Trusted by NICUs and maternity hospitals in Patna, these systems safeguard premature and low-birth-weight infants."
  },
  {
    "title": "ICU Patient Warming Equipment for Critical Care",
    "description": "Pharmacle Health Care offers ICU-grade warming equipment in Patna to maintain stable body temperature for critically ill patients. Designed to enhance recovery, our systems are a trusted choice for intensive care facilities."
  },
  {
    "title": "Surgical Patient Warming Equipment in Patna",
    "description": "Our advanced surgical warming systems ensure precise temperature regulation in operation theaters. By reducing hypothermia risks, they enhance surgical efficiency, safety, and post-operative recovery for patients in Patna."
  },
  {
    "title": "Preoperative & Postoperative Warming Systems",
    "description": "Pharmacle Health Care provides warming solutions that keep patients comfortable before and after surgery. Widely used in Patna hospitals, these systems improve recovery rates and reduce post-surgical complications."
  },
  {
    "title": "Veterinary Patient Warming System in Patna",
    "description": "Our Veterinary Warming Systems are designed for animal care, ensuring stable thermal support during surgeries and treatments. Trusted by veterinary clinics in Patna, these systems deliver safe and effective results."
  },
  {
    "title": "Emergency Patient Warming Systems for Trauma Care",
    "description": "Pharmacle Health Care provides emergency warming devices in Patna that rapidly stabilize body temperature in trauma and shock cases. These systems are vital for emergency departments and ambulance services."
  },
  {
    "title": "Disposable Patient Warming Blankets in Patna",
    "description": "Ensure hygiene and patient safety with our Disposable Warming Blankets. Designed for single-use, these blankets pair perfectly with warming systems in hospitals and clinics across Patna."
  }
],

"services": [
    {
        "name": "Patient Warming Systems Patna",
        "description": "Pharmacle Health Care Private Limited offers advanced patient warming systems in Patna, designed to regulate body temperature during surgeries, recovery, and critical care. These systems help prevent hypothermia and ensure optimal patient safety and comfort."
    },
    {
        "name": "Patna Patient Warming Devices",
        "description": "We provide patient warming devices in Patna that are specifically designed to maintain a stable body temperature during medical procedures. These devices help improve patient safety and comfort, ensuring a controlled and stable environment during surgeries and recovery."
    },
    {
        "name": "Forced Air Warming System Patna",
        "description": "Our forced air warming systems in Patna are ideal for maintaining patient body temperature during surgical procedures, recovery, and critical care. These systems circulate warm air to prevent hypothermia and ensure the patient stays comfortable throughout their medical treatment."
    },
    {
        "name": "Medical Warming Solutions Patna",
        "description": "We offer medical warming solutions in Patna that are designed to prevent hypothermia and provide patient comfort during surgeries and medical treatments. These solutions ensure stable body temperature regulation, enhancing patient safety and overall treatment outcomes."
    },
    {
        "name": "Patna Patient Thermoregulation Solutions",
        "description": "Pharmacle Health Care provides patient thermoregulation solutions in Patna, offering effective ways to manage and regulate body temperature during medical treatments. These solutions are essential for ensuring patient safety during surgeries and recovery processes."
    },
    {
        "name": "Patna Temperature Management Systems",
        "description": "Our temperature management systems in Patna are designed to maintain a safe body temperature during medical treatments. These systems are crucial for regulating patient body temperature during surgeries, critical care, and recovery, ensuring optimal comfort and safety."
    }
],
"tableData": [
    ["- Patient Warming Systems Patna", "- Patna Patient Warming Devices"],
    ["- Forced Air Warming System Patna", "- Medical Warming Solutions Patna"],
    ["- Patna Patient Thermoregulation Solutions", "- Patna Temperature Management Systems"]
],

"whychoose": [
    {
        "WhyChooseheading": "Advanced and Reliable Warming Technology",
        "WhyChoosedescription": "Pharmacle Health Care Private Limited offers advanced patient warming systems in Patna, designed to provide precise temperature control during medical treatments. Our technology ensures reliable performance to prevent hypothermia, enhancing patient safety in hospitals and clinics across Patna."
    },
    {
        "WhyChooseheading": "Comprehensive Patient Warming Solutions",
        "WhyChoosedescription": "We offer a wide range of patient warming systems in Patna, including forced air warming devices, blankets, and temperature control systems. Our solutions are tailored for both surgical procedures and critical care, ensuring your patients remain comfortable and safe throughout their treatment."
    },
    {
        "WhyChooseheading": "High-Quality, Durable Equipment",
        "WhyChoosedescription": "Our patient warming systems are manufactured to the highest quality standards, ensuring durability and long-lasting performance. Regularly tested and maintained, our equipment provides optimal reliability for continuous use in medical settings across Patna."
    },
    {
        "WhyChooseheading": "Safe and Comfortable for Patients",
        "WhyChoosedescription": "Patient safety and comfort are our top priorities. Our patient warming systems provide controlled, gentle warmth to prevent temperature-related complications during surgeries and procedures, ensuring that patients in Patna are always in the safest hands."
    },
    {
        "WhyChooseheading": "Flexible Solutions for Healthcare Providers",
        "WhyChoosedescription": "Our patient warming systems in Patna are adaptable to various healthcare settings, including hospitals, clinics, and emergency rooms. We work closely with healthcare providers to ensure our systems meet their specific needs, improving overall patient care."
    },
    {
        "WhyChooseheading": "Easy Integration with Existing Systems",
        "WhyChoosedescription": "Pharmacle Health Care’s patient warming systems are designed for seamless integration with existing medical systems in Patna. Our products can be quickly implemented, ensuring smooth and efficient operation without disrupting ongoing medical procedures."
    },
    {
        "WhyChooseheading": "Expert Consultation and Support",
        "WhyChoosedescription": "We provide expert consultation services in Patna to help healthcare facilities select the right patient warming systems for their needs. Our team also offers ongoing support and maintenance to ensure your equipment operates efficiently and reliably."
    },
    {
        "WhyChooseheading": "Commitment to Patient Safety and Comfort",
        "WhyChoosedescription": "At Pharmacle Health Care Private Limited, patient safety and comfort are at the core of everything we do. Our patient warming systems are designed to prevent temperature-related issues during critical medical procedures, ensuring that every patient in Patna receives the highest standard of care."
    }
]











  }


  const faqData = [
    { question: "What is a Patient Warming System?", answer: "A Patient Warming System is a medical device designed to maintain and regulate a patient’s body temperature during surgeries or medical procedures. It helps prevent hypothermia by using various warming methods such as forced air or radiant heat." },
    { question: "How does the Patient Warming System work?", answer: "The system works by using controlled warming methods like forced air or conductive heat to maintain a patient’s body temperature within a safe range. This helps prevent temperature-related complications during medical procedures." },
    { question: "Is the Patient Warming System available in Patna?", answer: "Yes, Pharmacle Health Care Private Limited offers Patient Warming Systems in Patna, providing healthcare facilities with effective solutions for managing patient body temperature during medical treatments." },
    { question: "What are the benefits of using a Patient Warming System?", answer: "The benefits include preventing hypothermia, improving patient comfort, reducing surgical complications, accelerating recovery, and ensuring consistent body temperature regulation during medical procedures." },
    { question: "How long can the Patient Warming System maintain the patient’s temperature?", answer: "The system is designed to maintain the patient’s body temperature for the entire duration of the medical procedure, providing continuous and controlled warmth to ensure patient safety." },
    { question: "Is the Patient Warming System easy to use?", answer: "Yes, the Patient Warming System is designed with user-friendly controls, making it simple for healthcare professionals to adjust the temperature settings during medical treatments or surgeries." },
    { question: "Can the Patient Warming System be used in all types of surgeries?", answer: "Yes, the Patient Warming System is versatile and can be used in a wide range of surgeries and medical procedures, particularly those that require temperature regulation for patient safety and comfort." },
    { question: "Is the Patient Warming System safe for all patients?", answer: "Yes, the system is safe for most patients. However, it should always be used under the supervision of trained healthcare professionals to ensure proper temperature regulation and prevent overheating or underheating." },
    { question: "How can I purchase a Patient Warming System in Patna?", answer: "You can contact Pharmacle Health Care Private Limited directly, and our team will assist you with purchasing and delivering the Patient Warming System to your healthcare facility in Patna." },
    { question: "Does Pharmacle Health Care provide support for Patient Warming Systems?", answer: "Yes, we provide full support for the Patient Warming System, including installation, training for healthcare professionals, and ongoing maintenance services to ensure the system continues to function effectively." }
  ];
  
  const testimonialsData = [
    {
      text: 'We have been using the Patient Warming System from Pharmacle Health Care in our Patna hospital. It has significantly improved our ability to maintain patient safety and comfort during surgeries, particularly for long-duration procedures.',
      name: 'Dr. Amit Verma',
    },
    {
      text: 'The Patient Warming System from Pharmacle Health Care has been a great addition to our clinic in Patna. It is easy to use, reliable, and helps us maintain a stable body temperature for our patients during surgeries and treatments.',
      name: 'Dr. Neha Singh',
    }
  ];
  
  
  
  
  
  
  
  
  
  
  























  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8956322311",
      "+91 8421773700",

    ],
    email: "info@wallabieswarmcares.com"
  };


const Images = [
  {
    place: "/images/keyword/1.jpg",
    text: "Patient Forced Air Warming System in Pune",
    link: "/Patient-Forced-Air-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/2.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi",
  },
  {
    place: "/images/keyword/3.jpg",
    text: "Patient Forced Air Warmer in Mumbai",
    link: "/Patient-Forced-Air-Warmer-in-Mumbai",
  },
  {
    place: "/images/keyword/5.jpg",
    text: "Patient Warming Systems in Chennai",
    link: "/Patient-Warming-Systems-in-Chennai",
  },
  {
    place: "/images/keyword/6.jpg",
    text: "Patient Warmer in Bengaluru",
    link: "/Patient-Warmer-in-Bengaluru",
  },
  {
    place: "/images/keyword/7.jpg",
    text: "Normothermia Equipment in Hyderabad",
    link: "/Normothermia-Equipment-in-Hyderabad",
  },
  {
    place: "/images/keyword/8.jpg",
    text: "Patient Thermoregulation System in Ahmedabad",
    link: "/Patient-Thermoregulation-System-in-Ahmedabad",
  },
  {
    place: "/images/keyword/9.jpg",
    text: "Patient Warming Devices in Kolkata",
    link: "/Patient-Warming-Devices-in-Kolkata",
  },
  {
    place: "/images/keyword/10.jpg",
    text: "Patient Warming Blankets in Jaipur",
    link: "/Patient-Warming-Blankets-in-Jaipur",
  },
  {
    place: "/images/keyword/12.jpg",
    text: "Patient Forced Air Warming System in Surat",
    link: "/Patient-Forced-Air-Warming-System-in-Surat",
  },
  {
    place: "/images/keyword/13.jpg",
    text: "Forced Air Warming Blankets in Coimbatore",
    link: "/Forced-Air-Warming-Blankets-in-Coimbatore",
  },
  {
    place: "/images/keyword/14.jpg",
    text: "Patient Warming Blankets in Lucknow",
    link: "/Patient-Warming-Blankets-in-Lucknow",
  },
  {
    place: "/images/keyword/15.jpg",
    text: "Patient Forced Air Warmer in Chandigarh",
    link: "/Patient-Forced-Air-Warmer-in-Chandigarh",
  },
  {
    place: "/images/keyword/17.jpg",
    text: "Thermoregulation Systems in Indore",
    link: "/Thermoregulation-Systems-in-Indore",
  },
  {
    place: "/images/keyword/18.jpg",
    text: "Patient Warming Systems in Patna",
    link: "/Patient-Warming-Systems-in-Patna",
  },
  {
    place: "/images/keyword/19.jpg",
    text: "Patient Forced Air Warming System in Hyderabad",
    link: "/Patient-Forced-Air-Warming-System-in-Hyderabad",
  },
  {
    place: "/images/keyword/20.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi NCR",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi-NCR",
  },
  {
    place: "/images/keyword/21.jpg",
    text: "Forced Air Warming System in Noida",
    link: "/Forced-Air-Warming-System-in-Noida",
  },
  {
    place: "/images/keyword/22.jpg",
    text: "Patient Warming Devices in Bhopal",
    link: "/Patient-Warming-Devices-in-Bhopal",
  },
  {
    place: "/images/keyword/23.jpg",
    text: "Patient Warming Blankets in Kochi",
    link: "/Patient-Warming-Blankets-in-Kochi",
  },
  {
    place: "/images/keyword/24.jpg",
    text: "Patient Warming System in Pune",
    link: "/Patient-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/25.jpg",
    text: "Forced Air Warming Blankets in Bengaluru",
    link: "/Forced-Air-Warming-Blankets-in-Bengaluru",
  },
  {
    place: "/images/keyword/26.jpg",
    text: "Patient Warming Devices in Chennai",
    link: "/Patient-Warming-Devices-in-Chennai",
  },
  {
    place: "/images/keyword/27.jpg",
    text: "Patient Thermoregulation System in Surat",
    link: "/Patient-Thermoregulation-System-in-Surat",
  },
];


  const images = [
    { src: "/images/keyword/1.jpg", alt: "Image 1" },
    { src: "/images/keyword/5.jpg", alt: "Image 1" },
    { src: "/images/keyword/2.jpg", alt: "Image 1" },
    { src: "/images/keyword/18.jpg", alt: "Image 1" },
    { src: "/images/keyword/4.jpg", alt: "Image 1" },
    { src: "/images/keyword/7.jpg", alt: "Image 1" },
    { src: "/images/keyword/8.jpg", alt: "Image 1" },
    { src: "/images/keyword/19.jpg", alt: "Image 1" },
    { src: "/images/keyword/6.jpg", alt: "Image 1" },

  ];


  const jsonData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Patient Warming Systems in Patna",
    "description": "Discover advanced Patient Warming Systems in Patna for effective patient thermoregulation and temperature management during medical procedures. Our systems provide optimal comfort and safety in hospital settings.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.8",
      "ratingCount": "1440"
    }
  };
  

  


  return (
    <div>
  <Helmet>
    <title>Patient Warming Systems in Patna | Contact: +91 8956322311</title>
    <meta
      name="description"
      content="Discover Patient Warming Systems in Patna for effective thermoregulation and temperature management during medical treatments. Contact us at +91 8956322311."
    />
    <meta
      name="keywords"
      content="Patient Warming Systems Patna, Patna Patient Warming Devices, Forced Air Warming System Patna, Medical Warming Solutions Patna, Patna Patient Thermoregulation Solutions, Patna Temperature Management Systems"
    />
    <script type="application/ld+json">
      {JSON.stringify(jsonData)}
    </script>
  </Helmet>
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>



      <section>
        <div className="container-fluid" >
          <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/13.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#1A76D1', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for  Pharmacle Health Care Private Limited</h3>
              
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
            
                <TestimonialKeyword testimonials={testimonialsData} />


              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a href={e.link} className="d-flex justify-content-around align-items-center">
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Gallery</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}

                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #1A76D1',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#1A76D1' }}>
                      <div>
                        <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>

                      <div className=''>
                        <a href="tel:+918956322311" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8956322311
                        </a>
                        <a href="tel:+918421773700" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8421773700
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@wallabieswarmcares.com" className=" text-white d-block">
                          <i className="fas fa-envelope darkcolorrr"></i> info@wallabieswarmcares.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                          <i className="fas fa-map-marker-alt darkcolorrr"></i>  Pharmacle Health Care Private Limited <br />
                          Gat No. 1251/2/3/1252 Plot No. 28, Block Sector, Weikfield Industrial Estate, Pune - Nagar Road, Sanaswadi, Pune, Maharashtra, 412208


                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Patientwarmingsysteminpatna;